import React, { useContext } from 'react';
import './LongestResponse.css';
import ModuleLoadingStatus from '../ModuleLoadingStatus/ModuleLoadingStatus';
import { CardLongestResponseContext } from '../../contexts/CardLongestResponseContext';
import logComponent from '../../common/logComponent';

export default function LongestResponseLoadingStatus({ reloadAction }) {
  const cardLongestResponseContext = useContext(CardLongestResponseContext);
  const { longestResponseLoading, longestResponseError } = cardLongestResponseContext;

  if (logComponent('LongestResponseLoadingStatus')) { console.debug('LongestResponseLoadingStatus rendered'); }


  return (
    <ModuleLoadingStatus isLoading={longestResponseLoading} isError={longestResponseError} reloadAction={reloadAction} />
  );
}